/**
 * Shown while a turn is working.
 *
 * It names what the agent is doing rather than animating alone, because a file search can take
 * several seconds and "Searching files…" is the difference between waiting and wondering.
 */
export function TypingIndicator({ label }: { label: string }): JSX.Element {
  return (
    <div className="typing" role="status" aria-live="polite">
      <span className="typing__dot" />
      <span className="typing__dot" />
      <span className="typing__dot" />
      <span className="typing__label">{label}</span>
    </div>
  );
}
